import { Fragment } from "react";
import { Button, message } from "antd";
import { useHistory } from "react-router-dom";
import { deleteOne } from "../../../api/bdPosibleParticipante";

/**
 * DeleteRecord
 * @param {Object} record
 * @param {Function} closeModal
 */
function DeleteRecord({ record, closeModal }) {
  const history = useHistory();

  // ------ Elimina usuario ------
  const handleDelete = async (userId) => {
    try {
      const response = await deleteOne(userId);
      message.success(response.message);
      closeModal();
      history.replace("/app/bdparticipante");
    } catch (err) {
      message.error(err.message);
    }
  };

  // ----- render -----
  return (
    <Fragment>
      <p className="mt-2 mb-6 text-base">
        ¿Estás seguro de eliminar al posible participante
        <span className="text-red-500 my-5">
          {" " + record.nombre + " " + record.apellido}
        </span>
        ?
      </p>
      <div
      className="flex justify-end gap-4"
      >
      <Button
        type="danger"
        htmlType="submit"
        onClick={() => handleDelete(record._id)}
      >
        Eliminar
      </Button>
      <Button
        type="default"
        onClick={() => closeModal()}
      >
        Cancelar
      </Button>
      </div>
    </Fragment>
  );
}
export default DeleteRecord;
